import { BoxTitles } from "@boxes/BoxTitles";
import { BoxTypes } from "@boxes/BoxTypes";
import { BoxValidations } from "@boxes/BoxValidations";
import { FlowBox } from "@boxes/FlowBox";
import style from "@styles/pages/flow/boxes/Box.module.scss";
import { memo } from "react";
import FilterBaseBox from "../layout/FilterBaseBox";
import { ReportFooter } from "../layout/ReportFooter";

export default memo(({ id, data, selected, isConnectable }) => {
  const subline = () => {
    const str = FlowBox.getSublineByType(BoxTypes.RFVProfileFilter, data);
    return str ? <div className={style.subline}>{str}</div> : null;
  };

  return (
    <FilterBaseBox
      id={id}
      selected={selected}
      valid={BoxValidations.validate(BoxTypes.RFVProfileFilter, data)}
      title={BoxTitles.RFVProfileFilter}
      isConnectable={isConnectable}
      footer={<ReportFooter id={id} />}
    >
      {subline()}
    </FilterBaseBox>
  );
});
